/**
 * Display types used by the Heartbeat service.
 *
 * @remarks
 * This value may be specified by the client directly.
 * If not provided, the client type is determined automatically.
 */
export const HeartbeatDisplayType = {
  /**
   * This roughly means that the player is embedded in a browser.
   *
   * @remarks
   * This is the fallback type if no specific type is applicable or given.
   */
  Online: '1',

  /**
   * The player is running on a mobile device.
   *
   * @remarks
   * The player can detect this type automatically.
   */
  Smartphone: '2',

  /**
   * The player is running on a tablet.
   *
   * @remarks
   * The player can detect this type automatically.
   */
  Tablet: '3',

  /**
   * The player is running on a SmartTV or a Set-Top-Box.
   * This includes all devices that are connected to a TV.
   *
   * @remarks
   * The player can detect this type automatically.
   */
  SmartTV: '4',

  /**
   * The player is running on a streaming stick like Amazon Fire TV Stick or Google Chromecast.
   * Both are currently not applicable, because the HTML5 Foundation Player is not supported on these devices.
   */
  Stick: '5',
} as const;

/**
 * {@inheritDoc HeartbeatDisplayType:var}
 */
export type HeartbeatDisplayType = (typeof HeartbeatDisplayType)[keyof typeof HeartbeatDisplayType];
